import types from './types'
import { apiMnemonics } from '../../api'

const updateAct = (event, opId) => ({ type: types.update, event, opId })

const addAct = (event, opId) => ({ type: types.add, event, opId })

const addTicket = (event, opId) => (dispatch, getState) => {
  const { id } = getState().user

  dispatch(addAct(event, id || opId))
}

const updateTicket = (event) => (dispatch, getState) => {
  const { tabs: { activeUser }, user: { id, onlyAssignedConversations }, mnemonics } = getState()

  const isUserInState = mnemonics.users[event.userId]

  if (event.userId !== activeUser || isUserInState) {
    if (onlyAssignedConversations && !event.assignedTo?.includes(id)) return

    return dispatch(updateAct(event, id))
  }

  if (event.pendingMsgCount > 0) {
    dispatch(seenTicket({ ticketId: activeUser }))
  }
}

const seenTicket = ({ ticketId, subjectId, removeByOperator, onFinish }) => (dispatch, getState) => {
  if (!ticketId) return

  const { mnemonics } = getState()
  const isUserInState = mnemonics.users[ticketId]

  const data = {}
  if (ticketId) data.ticketId = ticketId
  if (subjectId) data.subjectId = subjectId
  if (removeByOperator) data.removeByOperator = removeByOperator

  apiMnemonics
    .seen(data)
    .then(() => {
      if (isUserInState && !subjectId) {
        dispatch(seenAct(ticketId))
      }
      if (typeof onFinish === 'function') onFinish()
    })
}

const seenAct = (activeUser) => ({ type: types.seen, activeUser })

const getMnemonics = (operatorId) => async (dispatch) => {
  try {
    const { data } = await apiMnemonics.get()
    dispatch(addTicket(data, operatorId))
  } catch (error) {
    const event = {
      mainPool: 0,
      assignedTo: 0,
      users: {}
    }
    dispatch(addTicket(event, operatorId))
  }
}

export {
  updateTicket,
  seenTicket,
  getMnemonics
}
